// extracted by mini-css-extract-plugin
export default {"isCollapsedButton":"ShowMoreButton_isCollapsedButton__94gh5","isCollapsedIcon":"ShowMoreButton_isCollapsedIcon__jp9H-"};